import { createFeatureSelector, createSelector } from '@ngrx/store';
import { authorizedFeatureKey, AuthorizedState } from './authorized.reducer';

export const selectAuthorizedState = createFeatureSelector<AuthorizedState>(authorizedFeatureKey);

export const selectAuthorizedStateAction = createSelector(
  selectAuthorizedState,
  (state) => state.action,
);

export const selectUser = createSelector(selectAuthorizedState, (state) => state.user);

export const selectProfile = createSelector(selectAuthorizedState, (state) => state.profile);

export const selectMfaSettings = createSelector(selectAuthorizedState, (state) => {
  return state.profile?.mfa_settings;
});

export const selectSpotlightDirectories = createSelector(selectAuthorizedState, (state) => {
  return state.spotlightDirectories ? [...state.spotlightDirectories] : null;
});

export const selectLinkedEmails = createSelector(
  selectAuthorizedState,
  (state) => state.linkedEmails,
);

export const selectSkills = createSelector(selectAuthorizedState, (state) => state.skills);
